import ENV from "config/Env";
import { backendQueryKey } from "hooks/useTypedQuery";

export type XentryJobValue = string | number | boolean | null | XentryJobValue[] | { [key: string]: XentryJobValue };

export type XentryJob = { [key: string]: XentryJobValue };

const component = "XentryStatus";

export const XentryJobQueryKeys = {
  job: (appointment_id?: number) => backendQueryKey<XentryJob>({ component, baseUrl: ENV.appointmentBaseURL, endpoint: "/xentry/job", params: { appointment_id } })
};
